<template>
    <div>
        <h1>Issued Liquidations</h1>
    </div>
</template>

<script>
export default {
    name: "IssuedLiquidationsList",
};
</script>

<style></style>